import { render, staticRenderFns } from "./index-landing-three.vue?vue&type=template&id=85ed810c&"
import script from "./index-landing-three.vue?vue&type=script&lang=js&"
export * from "./index-landing-three.vue?vue&type=script&lang=js&"
import style0 from "./index-landing-three.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports